var map = {
	"./_default/cropped-image-750x350 (4).png": 246,
	"./restaurant/cropped-image-750x350 (1).png": 9322,
	"./restaurant/cropped-image-750x350 (2).png": 7099,
	"./restaurant/cropped-image-750x350 (3).png": 8596,
	"./restaurant/cropped-image-750x350.png": 9432
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7349;